import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { CampaignProps } from './types/propTypes';

const validationSchema = Yup.object().shape({
  businessName: Yup.string().required('Business name is required').nullable(),
  websiteUrl: Yup.string().url('Enter a valid URL').nullable().required('Website URL is required'),
});

const CampaignInformation: React.FC<CampaignProps> = ({ setCampaignData, campaignData ,setIsStepValid  }) => {
  return (
    <div className="my-8 p-6 border border-[#E5E7E7] rounded-2xl">
      <div className="max-w-2xl mx-auto">
        <h2 className="text-[28px] text-center font-semibold font-inter text-black mb-10">
          Campaign Information
        </h2>
        <Formik
          initialValues={{
            businessName: campaignData.businessName,
            websiteUrl: campaignData.websiteUrl,
          }}
          validationSchema={validationSchema}
        >
          {({ values, handleChange , isValid, dirty}) => {
            React.useEffect(() => {
              setCampaignData(prev => ({
                ...prev,
                businessName: values.businessName,
                websiteUrl: values.websiteUrl,
              }));
              setIsStepValid(isValid && dirty);

            }, [values, isValid, dirty]);
            

            return (
              <Form className="space-y-4">
                {/* Business Name Input */}
                <div className="mb-4">
                  <label
                    htmlFor="businessName"
                    className="block text-[#4A4D4F] text-base font-normal font-inter mb-2"
                  >
                    Business name
                  </label>
                  <Field
                    type="text"
                    id="businessName"
                    name="businessName"
                    placeholder="Enter business name"
                    className="w-full px-4 py-2 border rounded-lg placeholder-grayscale-600 text-base font-inter font-normal outline-none"
                    onChange={handleChange}
                  />
                  <ErrorMessage
                    name="businessName"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                {/* Website URL Input */}
                <div className="mb-4">
                  <label
                    htmlFor="websiteUrl"
                    className="block text-[#4A4D4F] text-base font-normal font-inter mb-2"
                  >
                    Website URL
                  </label>
                  <Field
                    type="url"
                    id="websiteUrl"
                    name="websiteUrl"
                    className="w-full px-4 py-2 border rounded-lg placeholder-grayscale-600 text-base font-inter font-normal outline-none"
                    placeholder="Enter website URL"
                    onChange={handleChange}
                  />
                  <ErrorMessage
                    name="websiteUrl"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default CampaignInformation;
